import React, { useMemo, useState } from 'react'
import { Autocomplete, AutocompleteOption } from '../Autocomplete'

interface FilterSelectProps {
  options: Array<AutocompleteOption>
  value?: AutocompleteOption
  onSelect: (option: AutocompleteOption | undefined) => void
  placeholder: string
  icon?: React.ReactNode
  loading?: boolean
  emptyMessage?: string
  clearable?: boolean
  /** change to remount and clear the input after a multi-select pick */
  resetKey?: string | number
}

/** Autocomplete over a preloaded list, filtered locally by the typed query. */
export const FilterSelect: React.FC<FilterSelectProps> = ({
  options,
  value,
  onSelect,
  placeholder,
  icon,
  loading,
  emptyMessage,
  clearable = false,
  resetKey,
}) => {
  const [query, setQuery] = useState('')

  const filtered = useMemo(() => {
    const phrase = query.trim().toLowerCase()
    if (!phrase) return options
    return options.filter((option) => option.label.toLowerCase().includes(phrase))
  }, [options, query])

  return (
    <Autocomplete
      key={resetKey}
      options={filtered}
      value={value}
      onChange={onSelect}
      onQueryChange={setQuery}
      loading={loading}
      placeholder={placeholder}
      icon={icon}
      emptyMessage={emptyMessage}
      clearable={clearable}
      fitWidth
    />
  )
}
